// Overview values use only the already loaded, tenant/date-scoped page.
// Never infer zero for unavailable provider data or combine reporting currencies.
export function campaignInventoryOverview(campaigns, summaries) {
  const rows = campaigns.map((campaign) => ({
    campaign,
    summary: summaries.get(campaign.id),
  }));
  const available = (metric) => metric?.availability === 'available'
    && Number.isFinite(metric.value) && metric.value >= 0;
  const leads = rows.filter(({ summary }) => available(summary?.performance?.metrics?.metaReportedLeads));
  const spend = rows.filter(({ summary }) => available(summary?.performance?.metrics?.spend));
  const currencyOf = ({ summary }) => summary?.performance?.account?.currency
    || summary?.performance?.metrics?.spend?.unit;
  const currencies = new Set(spend.map(currencyOf));
  const currency = currencies.size === 1 && /^[A-Z]{3}$/.test([...currencies][0] || '')
    ? [...currencies][0] : '';
  const paired = spend.filter(({ summary }) => available(summary.performance.metrics.metaReportedLeads));
  const pairedLeads = paired.reduce((sum, { summary }) => sum + summary.performance.metrics.metaReportedLeads.value, 0);
  const pairedSpend = paired.reduce((sum, { summary }) => sum + summary.performance.metrics.spend.value, 0);
  const statusCount = (statuses) => rows.filter(({ campaign, summary }) => !campaign.archivedAt
    && statuses.includes(summary?.settings?.status || campaign.status)).length;
  return {
    count: rows.length,
    leads: leads.length ? leads.reduce((sum, { summary }) => sum + summary.performance.metrics.metaReportedLeads.value, 0) : null,
    leadCount: leads.length,
    spend: spend.length && currency ? spend.reduce((sum, { summary }) => sum + summary.performance.metrics.spend.value, 0) : null,
    spendCount: spend.length,
    currency,
    mixedCurrencies: currencies.size > 1,
    costPerLead: currency && pairedLeads > 0 ? pairedSpend / pairedLeads : null,
    pairedCount: paired.length,
    active: statusCount(['active']),
    paused: statusCount(['paused']),
    draftsAndReview: statusCount(['draft', 'awaiting_approval', 'approved']),
    stale: rows.some(({ summary }) => summary?.performance?.freshness?.state === 'stale'),
    partial: rows.some(({ summary }) => summary?.performance?.availability === 'partial'),
  };
}
